export default __webpack_public_path__ + "static/media/linkdin.88fc567a.svg";